module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-us"
  }, [_c('div', {
    staticClass: "about-us-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "about-introduction",
    domProps: {
      "innerHTML": _vm._s(_vm.companyInfo.aboutCompany)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "paragraph-wrapper"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._m(2), _vm._v(" "), _c('el-row', {
    staticClass: "row-indent"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v("联系电话：" + _vm._s(_vm.companyInfo.tel))]), _vm._v(" "), _c('p', [_vm._v("公司地址：" + _vm._s(_vm.aboutUsInfo.address))])]), _vm._v(" "), _c('div', {
    attrs: {
      "span": 12
    }
  })], 1)], 1)]), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": require("../../static/images/usbj2.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-caption"
  }, [_c('h1', {
    staticClass: "anders"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "item-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/ilogo5.png"),
      "alt": ""
    }
  }), _vm._v("联系我们")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-caption"
  }, [_c('div', {
    staticClass: "point"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16553904"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AboutUs.vue
// module id = 1055
// module chunks = 1